module.exports = __webpack_public_path__ + "static/img/naat.4729c615.svg";